var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"layout-parent"},[_c('div',{staticClass:"side-bar-container"},[_c('Sidebar')],1),_c('div',{staticClass:"main-content-container"},[_c('div',{staticClass:"header-container"},[_c('Header')],1),_c('div',{staticClass:"main-content"},[_vm._t("default"),_c('router-view')],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }